var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "chat-widget-reference-images-picker" }, [
    _c(
      "div",
      { staticClass: "chat-widget-reference-images-picker__grid" },
      _vm._l(_vm.images, function (image, index) {
        return _c(
          "div",
          {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.keptIndexes.includes(index),
                expression: "keptIndexes.includes(index)",
              },
            ],
            key: index,
            staticClass: "chat-widget-reference-images-picker__item",
          },
          [
            _c("img", {
              staticClass: "chat-widget-reference-images-picker__img",
              attrs: { src: image.value, alt: image.display_name },
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "chat-widget-reference-images-picker__remove",
                attrs: {
                  type: "button",
                  disabled: _vm.disabled,
                  "aria-label": "Remove image",
                },
                on: {
                  click: function ($event) {
                    return _vm.remove(index)
                  },
                },
              },
              [_c("i", { staticClass: "bi bi-x-lg" })]
            ),
          ]
        )
      }),
      0
    ),
    _vm._v(" "),
    _c(
      "button",
      {
        staticClass: "btn btn-sm chat-widget-reference-images-picker__confirm",
        class: { "is-pending": _vm.keptIndexes.length > 0 },
        attrs: {
          type: "button",
          disabled: _vm.disabled || _vm.keptIndexes.length === 0,
        },
        on: { click: _vm.confirm },
      },
      [_vm._v("\n    " + _vm._s(_vm.confirmLabel) + "\n  ")]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }